import React from 'react'

const accessRightsSettingsRoutes = [
    {
        path: '/AccessRightsSettings',
        component: React.lazy(() => import('./AccessRightsSettings')),
        auth:'SA',
        accessPageName: 'ACCESSRIGHTSSETTINGS'
    },
    {
        path: '/AccessRightsSettingsWithId/([a-z0-9_]+)',
        component: React.lazy(() => import('./AccessRightsSettings')),
        auth:'SA',
        accessPageName: 'ACCESSRIGHTSSETTINGS'
    },
    ]

export default accessRightsSettingsRoutes